import React from 'react';
import { bool, objectOf, string } from 'prop-types';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

const ExtendedSize = (props) => {
    const {
        bottomBadge: { text },
        cardTheme,
        inDescription,
    } = props;

    const extendedSizeClasses = `${dt([
        'capitalize',
        'inline-block',
        'text-gray-500 text-small',
        'w-full',
        inDescription ? 'relative' : 'absolute',
    ])} ${cardTheme}`;

    return !inDescription && text ? (
        <div
            className={extendedSizeClasses}
            data-automation-id="product-extended-size"
            style={{ bottom: 0, left: 0 }}
        >
            {text}
        </div>
    ) : null;
};

ExtendedSize.propTypes = {
    bottomBadge: objectOf(string),
    cardTheme: string,
    inDescription: bool,
};

ExtendedSize.defaultProps = {
    bottomBadge: { text: '' },
    cardTheme: '',
    inDescription: false,
};

export default ExtendedSize;
